var React = require('react');

function Bill232px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23.98 11.075v18.859a1.998 1.998 0 0 1-1.998 1.995H1.997a1.998 1.998 0 0 1-1.998-1.995V1.998C-.001.897.895.003 1.997.003h10.992c.045 0 .084.02.128.026a.771.771 0 0 1 .127.025c.172.046.331.12.452.242l9.883 9.867c.032.023.048.061.076.087.03.027.052.058.078.088.154.176.267.388.267.64 0 .034-.016.063-.02.097zm-9.992-7.666V9.98h6.581l-6.581-6.571zm7.994 8.566h-8.993c-.552 0-1-.446-1-.997V1.94H2l-.003 27.994h19.985V11.975zM4.995 15.966h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm0 3.991h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm0 3.991h7.994a.998.998 0 1 1 0 1.995H4.995a.998.998 0 1 1 0-1.995zm11.991-7.982h1.998a.998.998 0 1 1 0 1.995h-1.998a.998.998 0 1 1 0-1.995zm0 3.991h1.998a.997.997 0 1 1 0 1.995h-1.998a.998.998 0 1 1 0-1.995zm0 3.991h1.998a.997.997 0 1 1 0 1.995h-1.998a.999.999 0 0 1 0-1.995z","key":1})]);
}

Bill232px.displayName = "Bill232px";

Bill232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 24 31.94"};

module.exports = Bill232px;

Bill232px.default = Bill232px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/bill-2-32px.svg
// module id = 1088
// module chunks = 0